module.exports = __webpack_public_path__ + "static/media/homelogo.9a8c754d.svg";